import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Playlist {
  id: string;
  created_at: string;
  name: string;
  creator_id: string;
  expires_at: string;
  is_active: boolean;
}

export interface Song {
  id: string;
  playlist_id: string;
  title: string;
  artist: string;
  url: string;
  votes: number;
  added_by: string;
  created_at: string;
  album_artwork: string | null;
  played: boolean;
  spotify_id: string;
  is_currently_playing: boolean;
  play_progress: number;
  played_at: string | null;
  last_updated: string | null;
}
